import { createContractRequest } from './helper';
export const postAdvisoriesCopy = createContractRequest({
    route: '/contract/advisories/copy',
    method: 'post',
    source: 'data',
});
